import script from "./work-order-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./work-order-modal.vue?vue&type=script&setup=true&lang=ts"

import "./work-order-modal.vue?vue&type=style&index=0&id=42fab7fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fab7fa"]])

export default __exports__